import { Component, Input, OnInit } from '@angular/core';
import { ContactsService } from '../shared/services/contacts.service';

@Component({
  selector: 'cc-row-tags-editor-wrapper',
  templateUrl: './row-tags-editor-wrapper.component.html',
  styleUrls: ['./row-tags-editor-wrapper.component.scss']
})
export class RowTagsEditorWrapperComponent implements OnInit {
  public top: number;
  public left: number;
  public rowTagEditorOpened = false;
  public rowId: number;
  private bottom: number;

  constructor(public contactsService: ContactsService) {}

  ngOnInit() {
    this.contactsService.toggleShowTagsEditor.subscribe((opener: boolean) => {
      this.rowTagEditorOpened = opener;
    });

    this.contactsService.onSetTagEditorPosition.subscribe(position => {
      const windowHeight = window.innerHeight;
      const border = windowHeight/2;
      if (position && position.top > border) {
        this.bottom = windowHeight - position.top + 20;
        this.left = position.left - 170;
        this.top = null;
        this.rowId = position.rowId;
      } else if (position && position.top <= border) {
        this.top = position.top + 20;
        this.bottom = null;
        this.left = position.left - 170;
        this.rowId = position.rowId;
      }
    });
  }

  rowEditorExit($event) {
    if ($event.target.className.includes('tag-editor-background')) {
      this.contactsService.toggleShowRowTagsEditor(false);
    }
  }
}
